import React, { useState, useRef, useEffect } from 'react';

interface FloatingModalProps {
  buttonRef: React.RefObject<HTMLSpanElement> | null;
  onClose: () => void;
  children: React.ReactNode;
  adjust?: boolean;
}

const FloatingModal: React.FC<FloatingModalProps> = ({
  children,
  buttonRef,
  onClose,
  adjust = true
}) => {
  const [position, setPosition] = useState({
    top: '0px' as string,
    left: '0px' as string,
    right: '0px' as string
  });
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (buttonRef?.current) {
      const rect = buttonRef.current.getBoundingClientRect();

      if (adjust) {
        setPosition({
          top: `${rect.top + window.scrollY - 100}px`,
          left: `${rect.right + window.scrollX + 30}px`,
          right: 'initial'
        });
      } else {
        const alignLeft = window.innerWidth - rect.right < 200;
        setPosition({
          top: '-20px',
          left: alignLeft ? 'initial' : '30px',
          right: alignLeft ? 'calc(100% + 10px)' : 'initial'
        });
      }
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        !buttonRef?.current?.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [buttonRef, onClose]);

  if (!buttonRef) return null;

  return (
    <div
      ref={modalRef}
      style={{
        position: 'absolute',
        top: position.top,
        left: position.left,
        right: position.right,
        background: 'white',
        padding: '10px',
        border: '1px solid #ccc',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: '5px',
        zIndex: 1000
      }}
    >
      {children}
    </div>
  );
};

export default FloatingModal;
